import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import Error404 from 'components/routes/NotFound/NotFound'

// DOCUMENTATION
// если определить baseComponent прямо в атрибуте, то это каждый раз будет новый компонент
// и будет демонтироваться и монтироваться занового
//
//...............................
//   <RouteWithSubRoutes
//     path="/settings"
//     baseComponent={ () => <div> ПЛОХО </dic> }
//       /^\/settings/,
//     ]}
//   />
//..................................
//   const baseComponent =  () => <div> ХОРОШО </dic>
//
//   <RouteWithSubRoutes
//     path="/settings"
//     baseComponent={baseComponent}
//       /^\/settings/,
//     ]}
//   />

const RouteWithSubRoutes = ({ path, subRoutes, baseComponent: BaseComponent }) => (
  <Route path={path} render={(props) => {
    return  _.some(subRoutes, regexp => regexp.test(props.location.pathname) )
      ? <BaseComponent {...props} />
      : <Error404 />
  }} />
);

RouteWithSubRoutes.propTypes = {
  path: PropTypes.string.isRequired,
  subRoutes: PropTypes.array.isRequired,
  baseComponent: PropTypes.any.isRequired,
}

export default RouteWithSubRoutes;
